import React, { FC } from 'react';
import cx from 'classnames';
import { Archive, Restore } from '@mui/icons-material';
import Typography from 'new/elements/TypographySupport';
import type { ArchivalStatus as ArchivalStatusType } from 'src/@types';
import {
  ARCHIVAL_STATUS_LIVE,
  ARCHIVAL_STATUS_ARCHIVED,
  ARCHIVAL_STATUS_RESTORING,
} from 'js/constants/pipelineConstants';
import styles from './archivalStatus.module.scss';

type Props = {
  archivalStatus: ArchivalStatusType;
  className?: string;
  size?: 'normal' | 'small';
  id?: number | string;
};

const icons = {
  archived: Archive,
  restoring: Restore,
};

const ArchivalStatus: FC<Props> = ({ archivalStatus, className, id = '', size = 'normal' }) => {
  if (!archivalStatus || archivalStatus === ARCHIVAL_STATUS_LIVE) return null;

  let statusName: string;
  let statusDisplayName: string;

  switch (archivalStatus) {
    case ARCHIVAL_STATUS_ARCHIVED:
      statusName = 'archived';
      statusDisplayName = 'Archived';
      break;
    case ARCHIVAL_STATUS_RESTORING:
      statusName = 'restoring';
      statusDisplayName = 'Restoring';
      break;
    default:
      return null;
  }

  const iconClassName = styles[statusName];
  const Icon = icons[statusName];

  return (
    <div
      className={cx(styles.status, className, styles['status_' + size])}
      data-testid={`archival-status-${id}`}
    >
      <Icon className={cx(styles.icon, iconClassName)} />
      <Typography className={cx(styles.label, styles[statusName])}>{statusDisplayName}</Typography>
    </div>
  );
};

export default ArchivalStatus;
